import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"d-flex flex-gap-8",class:(_vm.color + "--text")},[_c('span',[_vm._v(_vm._s(_vm.label))]),(_vm.branch)?_c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var attrs = ref.attrs;
var on = ref.on;
return [_c(VIcon,_vm._g(_vm._b({attrs:{"small":"","color":_vm.color}},'v-icon',attrs,false),on),[_vm._v("share")])]}}],null,false,2537284829)},[_c('span',[_vm._v(_vm._s(_vm.branch))])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }